import Parse from "parse";

export async function saveAudioFile(audioData) {
  const parseFile = await new Parse.File(
    "commandAudio.ogg",
    Array.from(audioData)
  ).save();
  return parseFile.toJSON();
}

export async function createCommand(payload) {
  const command = await Parse.Cloud.run("createCommand", payload);
  if (command.audioFile) {
    command.audioFile = command.audioFile.toJSON();
  }
  delete command.user;
  return command;
}
export async function updateCommand(payload) {
  const command = await Parse.Cloud.run("updateCommand", payload);
  if (command.audioFile) {
    command.audioFile = command.audioFile.toJSON();
  }
  delete command.user;
  return command;
}
export function deleteCommand(commandId) {
  return Parse.Cloud.run("deleteCommand", { commandId });
}
export async function getCommands() {
  const parseCommands = await Parse.Cloud.run("getCommands");
  const commands = parseCommands.map((parseCommand) => {
    const command = parseCommand.toJSON();
    if (command.birthDate) {
      command.birthDate = command.birthDate.iso;
    }
    delete command.user;
    return command;
  });

  return commands;
}
